<div *ngIf="docItems else docitemloading">

  <app-confirm-delete-product-part [(display)]="confirmDeleteOn"
                                   [typeConfirmation]="typeDeleteConfirmation"
                                   [confirmText]="confirmText"
                                   (done)="onDeleteConfirmation($event)"></app-confirm-delete-product-part>

  <app-income-price-breakdown-dialog #priceBreakdownDialog></app-income-price-breakdown-dialog>

  <p-table #docItemTable [value]="docItems"
           dataKey="DOCITEMID"
           [loading]="loading"
           selectionMode="single"
           [(selection)]="sDI"
           (onRowSelect)="onRowSelect($event)"
           (onStateSave)="onStateSave($event)"
           (onStateRestore)="onStateRestore($event)"
           [rowHover]="true"
           [resizableColumns]="true"
           editMode="row"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped">

    <ng-template pTemplate="caption" *ngIf="showHeader">
      <div class="grid">
        <div class="col-4 mt-2">
          <div class="grid">
            <div class="col-10">
              <p-selectButton [options]="showDocRowsOptions" [(ngModel)]="showRowOptions"
                              multiple="multiple" optionLabel="name" optionValue="value" optionDisabled="disabled"
                              (onChange)="onRowsOptionChange($event)" styleClass="mr-2"
                              pTooltip="Показывать дополнительные поля документа" tooltipPosition="top">
              </p-selectButton>
            </div>
            <div class="col-2" style="margin: auto">
              <p-inputSwitch (onChange)="countEmptyModeChange($event)" [(ngModel)]="countEmpty" [disabled]="editMode" pTooltip="Учитывать позиции с нулевым количеством" tooltipPosition="top"></p-inputSwitch>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="grid mt-2 justify-content-end">
            <p-button icon="pi pi-euro" styleClass="p-button-success mr-2 hide-label" [disabled]="noItems || editMode" (onClick)="updMainPrice($event)"
                      pTooltip="Обновить цену в гривне (основной валюте)" tooltipPosition="top"></p-button>
            <p-button icon="pi pi-dollar" styleClass="p-button-success mr-2 hide-label" [disabled]="noItems || editMode" (onClick)="updCurrPrice($event)"
                      pTooltip="Обновить валютную цену" tooltipPosition="top"></p-button>
            <p-button icon="pi pi-save" styleClass="p-button-success mr-2 hide-label" (onClick)="onSaveRows($event)" [disabled]="!changes || editMode"
                      pTooltip="Сохранить изменения" tooltipPosition="top"></p-button>
            <p-button label="Отменить" icon="pi pi-undo" styleClass="p-button-warning mr-4 hide-label" (onClick)="onUndoRows($event)" [disabled]="!changes || editMode"
                      pTooltip="Отменить изменения в цене" tooltipPosition="top"></p-button>

            <p-button icon="pi pi-sort" styleClass="p-button-secondary mr-2 hide-label" (onClick)="cleanSortMode($event)" [disabled]="noItems || editMode"
                      pTooltip="Убрать сортировку" tooltipPosition="top"></p-button>

            <p-button label="Нумеровать" icon="pi pi-sort-numeric-down" styleClass="p-button-warning mr-4 hide-label" [disabled]="noItems || editMode" (onClick)="updateRowIndexes($event)"
                      pTooltip="Обновить индексы строк в документе" tooltipPosition="top"></p-button>

            <p-button label="Обновить" icon="pi pi-refresh" styleClass="p-button-success ml-2 mr-2 hide-label" (onClick)="reloadDocContent($event)" [disabled]="editMode"
                      pTooltip="Обновить содержимое таблицы" tooltipPosition="top"></p-button>
            <p-button label="XLSX" icon="pi  pi-file-excel" styleClass="p-button-info mr-2 hide-label" (onClick)="onExportData()"
                      pTooltip="Экспортировать содержимое документа" tooltipPosition="top" [disabled]="noItems || editMode"></p-button>
          </div>
        </div>
      </div>
      <div class="grid" *ngIf="allowTopButtons && allowEditControls">
        <div class="col">
          <div class="grid formgrid p-jc-start">
            <p-button label="Добавить строку" icon="pi pi-plus" (onClick)="onAddRow($event)" styleClass="p-button-success ml-2 hide-label" [disabled]="editMode"
                      pTooltip="Добавить новую строку" tooltipPosition="top"></p-button>
          </div>
        </div>
        <div class="col">
          <div class="grid formgrid justify-content-end">
            <p-button label="Удалить все строки" icon="pi pi-trash" (onClick)="onRemoveAllRow($event)" styleClass="p-button-danger mr-2 hide-label" [disabled]="editMode || noItems"
                      pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
            <p-button label="Удалить строку" icon="pi pi-minus" (onClick)="onRemoveRow($event)" styleClass="p-button-warning mr-2 hide-label" [disabled]="editMode || !selection"
                      pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 7rem" *ngIf="allowEditControls">
          <div class="col align-self-start">
            <p-selectButton [options]="showFilterOptions" [(ngModel)]="showFilterValue" multiple="multiple" optionValue="value" optionDisabled="disabled" optionLabel="icon"
                            pTooltip="Показывать фильтр по полям таблицы" tooltipPosition="top">
              <ng-template let-item pTemplate>
                <i [class]="item.icon"></i>
              </ng-template>
            </p-selectButton>
          </div>
        </th>
        <th pResizableColumn pSortableColumn="PRODCODE" style="width:25%">Код товара <p-sortIcon field="PRODCODE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="PRODCUSTCODE" style="width:8rem" *ngIf="seeTariffCode">Код УКТЗЕД <p-sortIcon field="PRODCUSTCODE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMPRODNAME" style="width:35%">Название товара <p-sortIcon field="DOCITEMPRODNAME"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMTEXT1" style="width:25%" *ngIf="seeDiNote">Примечание <p-sortIcon field="DOCITEMTEXT1"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMTEXT2" style="width:6rem" *ngIf="seeDiNote">Состав <p-sortIcon field="DOCITEMTEXT2"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMQTY" style="width:7rem">Количество <p-sortIcon field="DOCITEMQTY"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMLOCALSTOCK" style="width:6rem" *ngIf="!editMode">Склад до <p-sortIcon field="DOCITEMLOCALSTOCK"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="U4ETKA" style="width:6rem" *ngIf="!editMode">После <p-sortIcon field="U4ETKA"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMGLOBALSTOCK" style="width:6rem" *ngIf="!editMode">Общий <p-sortIcon field="DOCITEMGLOBALSTOCK"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="prodInfo.PRODRESERVE" style="width:6rem" *ngIf="!editMode && seeReservation">Резерв <p-sortIcon field="prodInfo.PRODRESERVE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="prodInfo.PRODSOLD" style="width:6rem" *ngIf="!editMode && seeReservation">Продано <p-sortIcon field="prodInfo.PRODSOLD"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="prodInfo.PRODONWAY" style="width:6rem" *ngIf="!editMode && seeReservation">В пути <p-sortIcon field="prodInfo.PRODONWAY"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMVPRICE" style="width:8rem">Цена $ <p-sortIcon field="DOCITEMVPRICE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMPRICEWOVAT" style="width:8rem" *ngIf="seeWoVAT">Цена без НДС <p-sortIcon field="DOCITEMPRICEWOVAT"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMPRICE" style="width:8rem">Цена <p-sortIcon field="DOCITEMPRICE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCINCOMEPRICE" style="width:8rem" *ngIf="seeProfit">Входная <p-sortIcon field="DOCINCOMEPRICE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMVSUM" style="width:8rem">Сумма $ <p-sortIcon field="DOCITEMVSUM"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMSUMWOVAT" style="width:8rem" *ngIf="seeWoVAT">Сумма без НДС <p-sortIcon field="DOCITEMSUMWOVAT"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCITEMSUM" style="width:8rem">Сумма <p-sortIcon field="DOCITEMSUM"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="PAYITEMCLIID" style="width:5rem"># <p-sortIcon field="PAYITEMCLIID"></p-sortIcon></th>
        <th style="width: 3rem"></th>
      </tr>

      <tr *ngIf="showFilter">
        <th pResizableColumn style="width: 7rem" *ngIf="allowEditControls">Фильтр =></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['PRODCODE']" (input)="docItemTable.filter($event.target.value, 'PRODCODE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeTariffCode"><input pInputText type="text" [(ngModel)]="cf3['PRODCUSTCODE']" (input)="docItemTable.filter($event.target.value, 'PRODCUSTCODE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCITEMPRODNAME']" (input)="docItemTable.filter($event.target.value, 'DOCITEMPRODNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeDiNote"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMTEXT1']" (input)="docItemTable.filter($event.target.value, 'DOCITEMTEXT1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeDiNote"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMTEXT2']" (input)="docItemTable.filter($event.target.value, 'DOCITEMTEXT2', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCITEMQTY']" (input)="docItemTable.filter($event.target.value, 'DOCITEMQTY', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="!editMode "><input pInputText type="text" [(ngModel)]="cf3['DOCITEMLOCALSTOCK']" (input)="docItemTable.filter($event.target.value, 'DOCITEMLOCALSTOCK', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="!editMode "><input pInputText type="text" [(ngModel)]="cf3['U4ETKA']" (input)="docItemTable.filter($event.target.value, 'U4ETKA', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="!editMode "><input pInputText type="text" [(ngModel)]="cf3['DOCITEMGLOBALSTOCK']" (input)="docItemTable.filter($event.target.value, 'DOCITEMGLOBALSTOCK', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="!editMode && seeReservation"><input pInputText type="text" [(ngModel)]="cf3['prodInfo.PRODRESERVE']" (input)="docItemTable.filter($event.target.value, 'prodInfo.PRODRESERVE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="!editMode && seeReservation"><input pInputText type="text" [(ngModel)]="cf3['prodInfo.PRODSOLD']" (input)="docItemTable.filter($event.target.value, 'prodInfo.PRODSOLD', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="!editMode && seeReservation"><input pInputText type="text" [(ngModel)]="cf3['prodInfo.PRODONWAY']" (input)="docItemTable.filter($event.target.value, 'prodInfo.PRODONWAY', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCITEMVPRICE']" (input)="docItemTable.filter($event.target.value, 'DOCITEMVPRICE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeWoVAT"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMPRICEWOVAT']" (input)="docItemTable.filter($event.target.value, 'DOCITEMPRICEWOVAT', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCITEMPRICE']" (input)="docItemTable.filter($event.target.value, 'DOCITEMPRICE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeProfit"><input pInputText type="text" [(ngModel)]="cf3['DOCINCOMEPRICE']" (input)="docItemTable.filter($event.target.value, 'DOCINCOMEPRICE', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCITEMVSUM']" (input)="docItemTable.filter($event.target.value, 'DOCITEMVSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeWoVAT"><input pInputText type="text" [(ngModel)]="cf3['DOCITEMSUMWOVAT']" (input)="docItemTable.filter($event.target.value, 'DOCITEMSUMWOVAT', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCITEMSUM']" (input)="docItemTable.filter($event.target.value, 'DOCITEMSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['PAYITEMCLIID']" (input)="docItemTable.filter($event.target.value, 'PAYITEMCLIID', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn style="width: 3rem">...</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-docItem let-editing="editing" let-ri="rowIndex">
      <tr *ngIf="isDocItemRowVisible(docItem, editing)" [pSelectableRow]="docItem" [pEditableRow]="docItem">

        <td *ngIf="allowEditControls">
          <button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onDiRowEditInit(docItem)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="editing" [disabled]="!allowSave(docItem)" pButton pRipple type="button" pSaveEditableRow icon="pi pi-save" (click)="onDiRowEditSave(docItem)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onDiRowEditCancel(docItem, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
        </td>

        <td style="overflow: visible !important; ">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <app-productselector [showLabel]="false" [searchText]="docItem.PRODCODE" [allowOld]="allowOld" (selectedProduct)="onProductSelection($event, docItem)" [style]="{'width':'60%'}"></app-productselector>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                <a [routerLink]="['/edit-product', docItem.PRODID]">{{docItem.PRODCODE}}</a>
              </div>
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; background-color:ghostwhite" *ngIf="seeTariffCode">{{docItem.PRODCUSTCODE}}</td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="docItem.DOCITEMPRODNAME" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              <input pInputText type="text" [(ngModel)]="docItem.DOCITEMPRODNAME" [style]="{'width':'100%'}" readonly alt="{{docItem.DOCITEMPRODNAME}}">
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis" *ngIf="seeDiNote">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="docItem.DOCITEMTEXT1" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              <input pInputText type="text" [(ngModel)]="docItem.DOCITEMTEXT1" [style]="{'width':'100%'}" readonly alt="{{docItem.DOCITEMTEXT1}}">
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="overflow: visible !important; text-overflow: ellipsis" *ngIf="seeDiNote">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-dropdown [options]="yesno" [(ngModel)]="docItem.DOCITEMTEXT2" [style]="{'width':'100%'}"
                          pTooltip="Разворачивать состав изделия при печати" tooltipPosition="top"></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">{{docItem.DOCITEMTEXT2}}</ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.DOCITEMQTY" [style]="{'width':'100%'}" step="1" style="text-align: right"
                     (change)="onDOCITEMQTYChange($event, docItem)" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              <span [class.shipped]="docItem.sha" [class.missed]="docItem.mst">{{docItem.DOCITEMQTY | number:'1.0-2'}}</span>
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite" *ngIf="!editMode">{{docItem.DOCITEMLOCALSTOCK | number:'1.0-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite" *ngIf="!editMode">{{docItem.U4ETKA | number:'1.0-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite" *ngIf="!editMode">{{docItem.DOCITEMGLOBALSTOCK | number:'1.0-2' }}</td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite" *ngIf="!editMode && seeReservation">
          <span *ngIf="docItem.prodInfo as pi else waiting">
            {{pi.PRODRESERVE | number:'1.0-2' }}
          </span>
        </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite" *ngIf="!editMode && seeReservation">
          <span *ngIf="docItem.prodInfo as pi else waiting">
            {{pi.PRODSOLD | number:'1.0-2' }}
          </span>
        </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite" *ngIf="!editMode && seeReservation">
          <span *ngIf="docItem.prodInfo as pi else waiting">
            {{pi.PRODONWAY | number:'1.0-2' }}
          </span>
          <ng-template #waiting>
            <span>---</span>
          </ng-template>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right" [class.curr-not-match]="docItem.cnm" [class.below-income]="docItem.bip">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.DOCITEMVPRICE" [style]="{'width':'100%'}" step="0.01" style="text-align: right"
                     (change)="onDOCITEMVPRICEChange($event, docItem)" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              {{docItem.DOCITEMVPRICE | number:'1.2-2'}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right" *ngIf="seeWoVAT">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.DOCITEMPRICEWOVAT" [style]="{'width':'100%'}" step="0.1" style="text-align: right"
                     (change)="onDOCITEMPRICEWOVATChange($event, docItem)" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              {{docItem.DOCITEMPRICEWOVAT | number:'1.2-2'}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right" [class.rate-not-match]="docItem.rnm" [class.below-income]="docItem.bip">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.DOCITEMPRICE" [style]="{'width':'100%'}" step="0.01" style="text-align: right"
                     (change)="onDOCITEMPRICEChange($event, docItem)" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              {{docItem.DOCITEMPRICE | number:'1.2-2'}}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite" *ngIf="seeProfit">
          <a href="javascript:void(0)" class="income-price-cell-link" title="Показати структуру ціни"
             (click)="openIncomePriceBreakdown(docItem)">{{docItem.DOCINCOMEPRICE | number:'1.2-2' }}</a>
        </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite">{{docItem.DOCITEMVSUM | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite" *ngIf="seeWoVAT">{{docItem.DOCITEMSUMWOVAT | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite">{{docItem.DOCITEMSUM | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.PAYITEMCLIID" [style]="{'width':'100%'}" min="0" step="10" style="text-align: right" (change)="onPAYITEMCLIIDChange($event, docItem)" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">{{docItem.PAYITEMCLIID | number:'1.0-0'}}</ng-template>
          </p-cellEditor>
        </td>

        <td>
          <button *ngIf="!docItem.hlt" pButton pRipple type="button" icon="pi pi-check" (click)="checkDiState($event, docItem)" class="p-button-rounded p-button-success p-button-text"></button>
          <button *ngIf="docItem.hlt" pButton pRipple type="button" icon="pi pi-exclamation-triangle" (click)="checkDiState($event, docItem)" class="p-button-rounded p-button-danger p-button-text"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer" *ngIf="inputDocument as doc">
      <tr>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right" *ngIf="allowEditControls">{{doc.DOCITEMS | number:'1.0-2'}}</td>
        <td></td>
        <td *ngIf="seeTariffCode"></td>
        <td></td>
        <td *ngIf="seeDiNote"></td>
        <td *ngIf="seeDiNote"></td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{doc.DOCTOTALITEMS | number:'1.0-2'}}</td>
        <td *ngIf="!editMode"></td>
        <td *ngIf="!editMode"></td>
        <td *ngIf="!editMode"></td>
        <td *ngIf="!editMode && seeReservation"></td>
        <td *ngIf="!editMode && seeReservation"></td>
        <td *ngIf="!editMode && seeReservation"></td>
        <td></td>
        <td *ngIf="seeWoVAT"></td>
        <td></td>
        <td *ngIf="seeProfit"></td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite">{{doc.DOCVSUM | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite" *ngIf="seeWoVAT">{{doc.DOCSUMWOVAT | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right; background-color:ghostwhite">{{doc.DOCSUM | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right"></td>
        <td></td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="grid mt-2" *ngIf="allowEditControls">
        <div class="col">
          <div class="grid formgrid p-jc-start">
            <p-button label="Добавить строку" icon="pi pi-plus" (onClick)="onAddRow($event)" styleClass="p-button-success ml-2" [disabled]="editMode"
                      pTooltip="Добавить новую строку" tooltipPosition="top"></p-button>
          </div>
        </div>
        <div class="col">
          <div class="grid formgrid justify-content-end">
            <p-button label="Удалить все строки" icon="pi pi-trash" (onClick)="onRemoveAllRow($event)" styleClass="p-button-danger mr-2" [disabled]="editMode || noItems"
                      pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
            <p-button label="Удалить строку" icon="pi pi-minus" (onClick)="onRemoveRow($event)" styleClass="p-button-warning mr-2" [disabled]="editMode || !selection"
                      pTooltip="Убрать выбранную строку" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>

      <div class="fluid formgrid grid" *ngIf="inputDocument as doc">
        <div class="field col-12 xl:col-1 sm:col-4">
          <label for="DS1" class="do-not-wrap-text">Количество позиций</label>
          <p-inputNumber id="DS1" [(ngModel)]="doc.DOCITEMS" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-12 xl:col-1 sm:col-4">
          <label for="DS2" class="do-not-wrap-text">Общее количество</label>
          <p-inputNumber id="DS2" [(ngModel)]="doc.DOCTOTALITEMS" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-12 xl:col-1 sm:col-4">
          <label for="DS4" class="do-not-wrap-text">Сумма в валюте</label>
          <p-inputNumber id="DS4" [(ngModel)]="doc.DOCVSUM" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-12 xl:col-1 sm:col-4" *ngIf="seeWoVAT">
          <label for="DS5" class="do-not-wrap-text">Сумма без НДС</label>
          <p-inputNumber id="DS5" [(ngModel)]="doc.DOCSUMWOVAT" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-12 xl:col-1 sm:col-4">
          <label for="DS6" class="do-not-wrap-text">НДС</label>
          <p-inputNumber id="DS6" [(ngModel)]="doc.DOCVAT" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-12 xl:col-1 sm:col-4">
          <label for="DS7" class="do-not-wrap-text">Сумма с НДС</label>
          <p-inputNumber id="DS7" [(ngModel)]="doc.DOCSUM" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">Пустой документ</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #docitemloading>
  <p>Содержимое документа загружается...</p>
</ng-template>
